import { Provider } from '@angular/core';
import { environment } from '../../environments/environment';
import { GraphCollectionApiService } from '../service/api/graph-collection-api.service';
import { GraphCollectionApiServiceMock } from './service/graph-collection-api.service.mock';
import { AuthenticationService } from '../service/authentication.service';
import { AuthenticationServiceMock } from './service/authentication.service.mock';
import { EventsScheduleApiServiceMock } from './service/events-schedule-api.service.mock';
import { EventsScheduleApiService } from '../service/api/events-schedule-api.service';

export function provideMockServices(): Provider[] {
    const providers = [];

    if (environment.useMockServices) {
        providers.push([
            { provide: GraphCollectionApiService, useClass: GraphCollectionApiServiceMock },
            { provide: EventsScheduleApiService, useClass: EventsScheduleApiServiceMock },
        ])
    }
    if (environment.useMockAuthentication) {
        providers.push([
            { provide: AuthenticationService, useClass: AuthenticationServiceMock },
        ])
    }
    return providers;
}
